import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import InfoBox from '../../../Components/InfoBox';

const styles = () => ({
  root: {},
  infoBox: {},
});

const WebsiteAgreementText = ({
  className,
  classes,
  isPrimaryClient,
}) => {
  return (
    <InfoBox
      className={classNames(classes.root, className)}
    >
      {isPrimaryClient
        ? (
          <React.Fragment>
            <Typography
              variant={'h6'}
              weight={'medium'}
              color={'primaryGray'}
              paragraph
            >
              {'As a client of Facet, by selecting the “I Agree” button, I elect to participate in the password-protected access portion of Facet Internet web site. I understand that my participation will allow me to review certain investment-related information published by Facet and unaffiliated third parties. This password-protected access is made available to clients of Facet free of charge. This authorization shall continue until canceled in writing.'}
            </Typography>
            <Typography
              className={classes.infoBox}
              variant={'h6'}
              weight={'medium'}
              color={'primaryGray'}
              paragraph
            >
              {'I understand that the password-protected section is a secure web site intended only to allow a client access to information relative to his/her/its specific account. I also understand that I will be assigned an individual password. I agree not to share my password with any other person. I hereby release and hold Facet harmless from any adverse consequences relative to any failure by me to keep the identity of my password secure.'}
            </Typography>
            <Typography
              className={classes.infoBox}
              variant={'h6'}
              weight={'medium'}
              color={'primaryGray'}
              paragraph
            >
              {'I, also, understand, authorize, and accept delivery of, at point of acknowledgement below and until notified by Client of any change, all required regulatory notices, disclosures and agreements via electronic mail and/or via Facet’s internet website. I understand it is my obligation to notify Facet, in writing, of any changes to my email address. I acknowledge that I have the ongoing ability to receive and open standard electronic mail and corresponding electronic documents. By execution below, I release and hold Facet harmless from any and all claims and/or damages of whatever kind resulting from Facet’s electronic transmission of information, provided that Facet has correctly addressed the electronic transmission to me and/or other intended recipient.'}
            </Typography>
          </React.Fragment>)
        : (
          <Typography
            variant={'h6'}
            weight={'medium'}
            color={'primaryGray'}
          >
            {'Please login with the primary client and sign the website access & electronic delivery acknowledgement to begin using the website.'}
          </Typography>)
      }
    </InfoBox>
  );
};

WebsiteAgreementText.defaultProps = {
  className: '',
};

WebsiteAgreementText.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  isPrimaryClient: PropTypes.bool.isRequired,
};

export default withStyles(styles)(WebsiteAgreementText);
